import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden h-48">
          <img
            src={article.image}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
              {article.category}
            </span>
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-line"></i>
                </span>
                {article.date}
              </span>
              <span className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                {article.readTime}
              </span>
            </div>
            <span className="flex items-center gap-1 text-primary-500 font-medium whitespace-nowrap">
              阅读更多
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}